export const modalCopies = {
    SKIP_STEP_VALID_FORM: 'Do you want to save your changes before you leave?',
    SKIP_STEP_INVALID_FORM: "You haven't finished filling out the information on this page. If you leave now, your work won't be saved.",
};
